module.exports = __webpack_public_path__ + "img/web_design.57c2844e.jpg";